const PKCE_STORAGE_KEY = "showmelive_cognito_pkce";

const base64Url = (bytes) => {
  let binary = "";
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return window.btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
};

export const randomUrlSafeValue = (length = 64) => {
  const bytes = new Uint8Array(length);
  window.crypto.getRandomValues(bytes);
  return base64Url(bytes);
};

export const pkceChallenge = async (verifier) => {
  const digest = await window.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier),
  );
  return base64Url(new Uint8Array(digest));
};

export const startCognitoLogin = async () => {
  const response = await fetch("/api/auth/social/cognito/config", {
    credentials: "include",
    cache: "no-store",
  });
  if (!response.ok) throw new Error("AWS email sign-in is unavailable");
  const config = await response.json();
  if (!config.enabled || !config.domain || !config.client_id || !config.redirect_uri) {
    throw new Error("AWS email sign-in is not configured");
  }

  const verifier = randomUrlSafeValue(64);
  const state = randomUrlSafeValue(32);
  const challenge = await pkceChallenge(verifier);
  window.sessionStorage.setItem(PKCE_STORAGE_KEY, JSON.stringify({
    verifier,
    state,
    redirect_uri: config.redirect_uri,
    created_at: Date.now(),
  }));

  const url = new URL("/oauth2/authorize", config.domain);
  url.search = new URLSearchParams({
    client_id: config.client_id,
    response_type: "code",
    redirect_uri: config.redirect_uri,
    scope: config.scope || "openid email profile",
    state,
    code_challenge: challenge,
    code_challenge_method: "S256",
  }).toString();
  window.location.assign(url.toString());
};

export const consumeCognitoPkce = (returnedState) => {
  const raw = window.sessionStorage.getItem(PKCE_STORAGE_KEY);
  window.sessionStorage.removeItem(PKCE_STORAGE_KEY);
  if (!raw) throw new Error("The email sign-in session expired");
  const saved = JSON.parse(raw);
  if (!saved.state || saved.state !== returnedState) {
    throw new Error("The email sign-in security check failed");
  }
  if (Date.now() - Number(saved.created_at || 0) > 15 * 60 * 1000) {
    throw new Error("The email sign-in session expired");
  }
  return saved;
};
